import React from 'react';
import { List, Pagination } from 'antd';
import "./Styles/ListComponent.scss";
import utils from 'utils';

var that;
export default class extends React.Component {
    _baseClassName = 'list-component';
    constructor(props) {
        super(props);
        this.state = {
            props: this.props,
            data: this.props.data,
            currentData: undefined,
            pagination: this.generatePaginationProps(),
            toggleLoadMore: false,
            renderType: this.props.renderType
        };
        that = this;
    }

    componentDidMount() {
        let {data, renderType} = this.state;
        this.setState({
            currentData: this.getCurrentData({data, renderType})
        })
        
    }

    getCurrentData({ data = [], renderType }) {
        let { initialLength } = this.props.showMore || {};
        let tempData = data && [...data] || data;
        let finalData = tempData || [];
        
        if(tempData && initialLength < tempData.length && !this.state.toggleLoadMore && this.props.showMore && renderType != "server") {
            finalData = tempData.slice(0, initialLength);
        }

        return finalData;
    }

    handlePagination(pageNo) {
        let {data, pagination, renderType} = this.state || {};
        this.setState({
            pagination: pagination,
            currentData: this.getCurrentData({
                data,
                renderType: renderType,
            })
        })

        typeof pagination.onChange == "function" && pagination.onChange(pageNo);
        
    }

    generatePaginationProps() {
        let pagination = { ...this.props.pagination } || {};
        if (this.props.renderType == "client") {
            delete pagination.total
        }
        return pagination;
    }

    handleShowMore() {
        let { renderType, data } = this.state;
        this.setState({
            toggleLoadMore: !this.state.toggleLoadMore,
        }, () => {
            this.setState({
                currentData: this.getCurrentData({data, renderType})
            })
        });
        
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps !== prevState.props) {
            let pagination = { ...nextProps.pagination } || {};
            if (nextProps.renderType == "client") {
                delete pagination.total
            }
            return { props: nextProps, pagination: pagination, data: nextProps.data, currentData: that.getCurrentData(nextProps || {}) };
        } else return null;
    }

    
    loadMore() {
        let { content, initialLength } = this.props.showMore || {};
        if(content) {
            return (
                <div className='load-more-content'>
                    {content}
                </div>
            );
        }
        return (
            <div className='load-more-content'>
                <div className='load-more-content-default'>
                    <div onClick={this.handleShowMore.bind(this)}>{`${!this.state.toggleLoadMore ? ("+ " + (this.state.data.length - initialLength) + " More") : "- View Less"}`}</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={`${this._baseClassName} ${this.props.className || ''}`} style={this.props.style || {}}>
                { utils.Render(<List
                    loading={false}
                    itemLayout="horizontal"
                    loadMore={this.props.showMore && this.loadMore()}
                    pagination={ this.state.currentData && this.state.currentData.length && this.props.pagination != null && this.props.renderType == "client" && !this.props.showMore ? {
                        onChange: (page) => {
                            // console.log(page);
                        },
                        defaultCurrent: 1,
                        pageSize: 5,
                        showQuickJumper: false,
                        showSizeChanger: false,
                        ...(this.state.pagination || {})
                    } : null}
                    dataSource={this.state.currentData || []}
                    footer={null}
                    renderItem={(item) => {
                        if (this.props.render && typeof this.props.render == "function") {
                            return <div style={{margin:"16px 0px"}} className='list-component-gap'>{this.props.render(item)}</div>
                        }
                    }}
                />, this.state.data, {handleFunction: this.props.handleRefresh, noDataContent: this.state.props?.noDataContent})}
                {this.props.renderType == "server"  && this.state.pagination && this.state.pagination?.total && !this.props.showMore ? <div style={{display: "flex", justifyContent: `${!this.props?.paginationRight ? "flex-end" : "flex-start"}`}}>
                <Pagination  pageSize={5} total={0} showQuickJumper={false} showSizeChanger={false} {...(this.state.pagination || {})} onChange={this.handlePagination.bind(this)} />
                </div> : null}
            </div>
        );
    }
}
